// import http from "./http-common";

// class AudioService {
//   queryString(payload) {
//     return Object.keys(payload)
//       .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
//       .join("&");
//   }
//   // 🔹 POST - Upload audio to backend (starts transcription)
//   AudioUpload(payload) {
//      const queryString = this.queryString(payload)
//     return http.post(`/api/assemblyai/transcribe${queryString}`);
//   }

//   // 🔹 GET - Check transcription status by transcriptId
//   GetTranscriptStatus(payload) {
//     const queryString = this.queryString(payload)
//     return http.get(`/api/assemblyai/get${queryString}`);
//   }
// }

// export default new AudioService();

import http from "./http-common";

class AudioService {
  // 🔹 POST - Upload audio with query params
  AudioUpload(formData) {
     const queryString = Object.keys(formData)
      .map((key) => (key && formData[key] ? `${key}=${formData[key]}` : ""))
      .join("&");

    return http.post(`/api/assemblyai/transcribe${queryString}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // 🔹 GET - Check transcription status
  GetTranscriptStatus(payload) {
    const queryString = Object.keys(payload)
      .map((key) => (key && payload[key] ? `${key}=${payload[key]}` : ""))
      .join("&");
    return http.get(`/api/assemblyai/get?${queryString}`);
  }
}

export default new AudioService();
